import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const UGIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="UG" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#FECA00"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path fill="#272727" d="M0 0h16v2H0z" />
        <Path fill="#D74800" d="M0 4h16v2H0z" />
        <Path fill="#272727" d="M0 6h16v2H0z" />
        <Path fill="#D74800" d="M0 10h16v2H0z" />
        <Path
          fill="#F7FCFF"
          fillRule="evenodd"
          d="M8 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
          clipRule="evenodd"
        />
        <Path
          fill="#272727"
          d="M7.212 3.821c.34 0 .543.344.543.344-.015.012-.448.33-.448.59 0 .267-.154.634.448.872.603.238 1.571.238 1.696.669.124.431-.233.59-.724.59-.49 0-.89-.205-.69 0 .2.207.71.696.355.696-.118 0-.565-.356-.582-.058-.01.19.202.707 0 .908-.048.047.596.144.549.188-.13.112-.38 0-.719 0-.043 0-.612.345-.67.342-.054-.003.385-.336.337-.342-.29-.028-.625.028-.637 0-.018-.049.735.014.895-.188.253-.32-.039-.939-.07-.942-.4-.037-.79-.043-.884.092-.177.257-.556.515-.556.386 0-.13-.204-.527.703-.527.908 0 .748-.098.748-.098v-.338c-.029-.007-1.37-.33-1.37-1.031 0-.71.618-1.055.703-1.218.084-.16.004-.365 0-.372l-.528-.046.528-.173s.033-.344.373-.344Zm.552 3.467c.014.004.355.092.283-.081-.071-.171-.271-.17-.283-.17v.251Z"
        />
        <Path
          fill="#D74800"
          fillRule="evenodd"
          d="m6.538 3.356.507.6.263-.061-.126-.607-.644.068Z"
          clipRule="evenodd"
        />
        <Path
          fill="#FFD018"
          fillRule="evenodd"
          d="m7.196 3.21.033.904.433-.107.184-.591-.65-.206Z"
          clipRule="evenodd"
        />
        <Path
          fill="#D74800"
          fillRule="evenodd"
          d="M6.788 4.72a.171.171 0 0 0 .174-.17.171.171 0 0 0-.174-.168.171.171 0 0 0-.173.169c0 .093.078.168.173.168ZM7.888 3.38l-.504.603.107.248.575-.23-.178-.621ZM9.06 7.947s.885-.396.885-.95c0-.554-1.439-1.157-1.439-1.157s-.846.194-.464.453c.381.26.892.36.892.704 0 .345.14.674-.144.674-.284 0 .27.276.27.276Z"
          clipRule="evenodd"
        />
        <Path
          fill="#FFFDFF"
          fillRule="evenodd"
          d="M7.78 5.74s-.313.054-.298.105c.041.141.47.324.657.451.381.26.743.23 1.012.062.27-.17-1.37-.619-1.37-.619Z"
          clipRule="evenodd"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
